/**
 * api接口统一管理
 */
import common from './common/common.js'
import map from './m/map.js'
import index from './m/index.js'

const api = {
    common,
    index,
    map
}

export default api;